import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-design-polygon-icon',
  templateUrl: './design-polygon.component.html'
})
export class DesignPolygonComponent extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
